module.exports = __webpack_public_path__ + "img/youtube.250b8ce6.svg";